import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentUsingOtherApi = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">6.Using the Other Api</h2>
            <div>
                <p><span className="font-bold">6.1</span> Select the M2M APIs radio button option from the left tab as shown in below screenshot.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/api_card_section.png"} />
            </div>

            <div>
                <p><span className="font-bold">6.2</span> Select any API card from the list to test the API or check documentation. As an example, the <span className="font-bold">Account Details</span> API Card is selected as shown below.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/documentation_tab.png"} />
                <p>As highlighted, you can click on <span className="font-bold">Documentation tab</span> to view the API documentation of Account-Details APIs.</p>

                <h3><span className="font-bold">Steps to view documentation</span></h3>

                <p>1. Click on API name (Fetch Customer profile) for which you want to see documentation as shown in above screenshot.</p>
                <p>2. Center panel of page will show complete documentation of API's including its requestBody, headers, params, response body etc. </p>
            </div>

            <div>
                <h3><span className="font-bold">6.3 Try It Out </span></h3>

                <p>You can also try-out(test) these APIs to get a quick glance of API request and response</p>

                <p><span className="font-bold">Step 1:</span> Click on <span className="font-bold">Try it Out</span> Option as highlighted in the screenshot below</p>

                <p><span className="font-bold">Step 2:</span> Click on <span className="font-bold">Fetch Customer Profile</span> Under Account Details Section of left side pane.</p>

                <p><span className="font-bold">Step 3:</span> Fill the headers(iv-user,customer-id) and click on TRY button as highlighted in the screenshot below</p>

                <p><span className="font-bold">Step 4:</span> You can see the response Body and response codes as shown in the screenshot below</p>

                <img className="pic" src={staticAssetsUrl + "user_manual/try_It_out_tab.png"} />
            </div>

        </div>
    )
}

export default ContentUsingOtherApi;